<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section concept" id="concept">
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">CONCEPT</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <Wrapper>
            <h3 class="description-title ">
              笑顔のための<span class="strong">いつもの</span>サロン
            </h3>

            <p><br></p>

            <p><v-icon>mdi-paw</v-icon> 一生を通していつもの変わらない日常の一コマであり続けたい</p>

            <p><br></p>

            <p>ワンコは人間よりも早いスピードで歳を重ねていきます。</p>
            <p>耳や目が不自由になる事もあります。</p>
            <p>立つことが困難になる時が来るかもしれません。</p>
            <p>ずっと可愛いふわふわのカットが出来なくなる事だってあるでしょう。</p>

            <p><br></p>

            <p>出来ることが変わっても</p>
            <p>それでも変わらないものって</p>
            <p>何だろう？</p>

            <p><br></p>

            <p>それは</p>
            <p>｢いつも｣の飼い主さんの笑顔</p>
            <p>｢いつも｣の日常</p>
            <p>ではないでしょうか？</p>

            <p><br></p>

            <p>飼い主さんの笑顔と</p>
            <p>その笑顔を見て喜ぶワンコの幸せの輪が</p>
            <p>いつまでも続きますように。</p>

            <p><br></p>

            <p>そのためのほんの少しのお手伝いをさせて頂けますと幸いです。</p>

            <p><br></p>

            <h3 class="description-title ">
               ①命・心が最優先
            </h3>
            <p>無理をしません。</p>
            <p>ワンコの声に耳を傾ける努力をいたします。</p>

            <p><br></p>

            <h3 class="description-title ">
              ②飼い主さん参加型サロン
            </h3>
            <p>誰よりもウチの子を知っている飼い主さんとその時何がベストかを一緒に考えます。</p>
            <p>小さな変化も共有いたします。</p>

            <p><br></p>

            <h3 class="description-title ">
               ③病院さんへの橋渡し
            </h3>
            <p>トリミングサロンでは治療はできません。</p>
            <p>それでもワンコに快適に過ごしてもらいたいと願っております。</p>
            <p>病院さんとの連携を致します。</p>

            <p><br></p>

            <p><span class="strong">｢いつも｣の日常の一コマ</span>として安心してご利用頂けますよう定期的なサロンのご利用をご提案させていただいております。</p>

          </Wrapper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Wrapper from './Wrapper'

export default {
  name: 'concept',
  components: {
    Wrapper,
  },
  data(){
    return {
      isIntersecting: false,
    }
  },
  methods: {
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}

</script>

<style>
/* .fade {
  animation: fadeIn 2s ease-in-out 0s;
} */
p {
  /* text-align: left; */
}

</style>
